export default __webpack_public_path__ + "dae65c36d9ef75bc6fb9a0dc2047fbf2.webp";